import { Component, inject } from '@angular/core';
import { OrganizationSettingsFiscalYearStore } from './organization-settings-fiscal-year.store';
import { TableColumn, TableColumnType } from '../../../../modules/shared/components/kit/table/table.types';
import { routeParams, translate } from '../../../../modules/shared/shared.global-service';
import { DividerModule } from '@openng/optimus-ui/divider';
import {
    OrganizationSettingsFiscalYearDialogComponent,
} from './dialog/organization-settings-fiscal-year-dialog.component';
import { TranslatePipe } from '@ngx-translate/core';
import { FilterBuilder } from '../../../../modules/content/helper/filter.builder';
import { FiscalYearObject } from '@libs/types/src/mado/object-type/organization/fiscal-year.object';
import { fiscalYearFrag } from './organization-settings-fiscal-year.query';
import { BaseDialogService } from '../../../kit/base-dialog/base-dialog-service';
import { TableComponent } from '../../../../modules/shared/components/kit/table/table.component';

@Component({
    selector: 'app-organization-settings-fiscal-year',
    templateUrl: './organization-settings-fiscal-year.component.html',
    providers: [OrganizationSettingsFiscalYearStore],
    imports: [
        DividerModule,
        TranslatePipe,
        TableComponent,
    ],
})
export class OrganizationSettingsFiscalYearComponent {
    protected readonly store = inject(OrganizationSettingsFiscalYearStore);
    protected readonly dialogService = inject(BaseDialogService);

    protected readonly prefix = 'organization-settings.mado.fiscalYear.';

    protected columns: TableColumn[] = [
        {
            name: 'dateFrom',
            type: TableColumnType.Date,
        },
        {
            name: 'dateTo',
            type: TableColumnType.Date,
        },
        {
            name: 'accountingType',
            type: TableColumnType.String,
            data: (data: any) => translate.instant(`${this.prefix}accountingTypeOptions.` + data),
        },
    ];

    constructor() {
        this.loadFiscalYears();
    }

    openDialog(data: FiscalYearObject | null = null) {
        const header = `${this.prefix}title` + (data ? 'Detail' : 'Create');
        const dialog = this.dialogService.open(
            OrganizationSettingsFiscalYearDialogComponent,
            {
                header: translate.instant(header),
                data: { fiscalYear: data },
            },
        );

        dialog?.onClose.subscribe((it) => {
            if (it === true) {
                this.loadFiscalYears();
            }
        });
    }

    loadFiscalYears() {
        const organizationId = routeParams.organizationId();

        if (organizationId) {
            const filter = new FilterBuilder();
            filter.where('organizationId', organizationId);
            filter.sort('dateFrom', 'DESC');
            filter.page(1);
            filter.limit(999);

            this.store.api.getFiscalYears(filter.filter(), fiscalYearFrag).then();
        }
    }
}
